import { useQuery } from '@tanstack/react-query';
import { DISCIPLINES_QUERY_KEY } from 'Data/keys/QueryKeys';
import ObrasApi from 'Data/Obras.api';
import { IListFilesRequest } from 'Data/interfaces/ListagemArquivos/IListFilesRequest';

export const useQueryDisciplinesListFiles = (props: IListFilesRequest) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [DISCIPLINES_QUERY_KEY, props.constructionSiteId, props.folderId],
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const response = await ObrasApi.listFiles(props);
      return response.data.data.Files.length;
    },
    enabled: !!props.constructionSiteId && !!props.folderId,
  });

  return {
    data,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
